<script>
    import { store } from '../../Store.svelte';
    let value = $store.personalDetails.portabilityNumber;
    let error = '';
    const isSky = $store.requestedServices.isSky;
    const tabsStyle = `--dynamic-rgba: ${isSky ? 'rgba(4, 8, 255, 0.342)' : 'rgba(211, 23, 114, 0.1)'}; 
                       --dynamic-color: ${isSky ? '#000ff5' : '#d31772'};`;
    let portabilityCheck = () => {
        error = '';
        if (!/^[0-9]{10}$/.test(value)) {
            error = 'Debes de ingresar un número telefónico válido';
            $store.personalDetails.portabilityNumber = '';
        } else {
            $store.personalDetails.portabilityNumber = value;
        }
    };

    let portabilityChange = () => {
        if (!$store.personalDetails.portabilityCheck) {
            $store.personalDetails.portabilityNumber = '';
        } else {
            $store.personalDetails.portabilityNumber = value;
        }
    };
</script>

<div class="pure-g m-b-15">
    <div class="pure-u-3-4">
        <p class="m-b-15">Trae tu línea telefónica residencial</p>
    </div>
    <div class="pure-u-1-4 text-right">
        <span class="checkbox-switch" style={tabsStyle}>
            <input
                type="checkbox"
                name="portabilidad_lineafija"
                id="portabilidad_lineafija"
                bind:checked={$store.personalDetails.portabilityCheck}
                on:change={portabilityChange}
            />
            <label for="portabilidad_lineafija"></label>
        </span>
    </div>
</div>
<div
    class="pure-u-1 m-b-15 {$store.personalDetails.portabilityCheck
        ? ''
        : 'hide'}"
>
    <div class="ctrl-holder">
        <label for="numeroportabilidad" class="placeholder"
            >Ingresa tu número telefónico fijo</label
        >
        <input
            type="text"
            name="numeroportabilidad"
            id="numeroportabilidad"
            maxlength="10"
            required
            bind:value
            on:input={portabilityCheck}
        />
        {#if error.length > 0}
            <label class="error" for="numeroCelular">{error}</label>
        {/if}
    </div>
</div>
<div
    class="inline-alert m-b-30 {$store.personalDetails.portabilityCheck
        ? ''
        : 'hide'}"
>
    <p class="m-b-0">
        El técnico te dará las instrucciones para realizar la portabilidad el
        día de tu instalación. Después de realizar la portabilidad el ahorro se
        verá reflejado en tu factura.
    </p>
</div>

<style>
    .hide {
        display: none;
    }
</style>
